module.exports = __webpack_public_path__ + "static/media/contact06.de47a03f.png";